// extracted by mini-css-extract-plugin
export var closeButton = "_2i-3";
export var header = "_2i-0";
export var link = "_2i-1";
export var retryButton = "_2i-2";